import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import * as endpoints from './endpoints';
import {
  getInterns,
  getInternsFailed,
  getInternsSuccess,
  updateInternStatus,
  updateInternStatusFailed,
  updateInternStatusSuccess,
  getInternDetails,
  getInternDetailsSuccess,
  getInternDetailsFailed,
  getInternTransaction,
  getInternTransactionFailed,
  getInternTransactionSuccess,
  updateIntern,
  updateInternSuccess,
  updateInternFailed,
  promoteAsEmployee,
  promoteAsEmployeeFailed,
  promoteAsEmployeeSuccess,
} from './slice';
import { RootState } from '@app/redux/root-reducer';
import { addEmployeeSuccess, updateEmployeeSuccess } from '../employees/slice';

function* getInternSaga(action: ReturnType<typeof getInterns>): any {
  try {
    const result = yield call(request.get, endpoints.getInterns);
    yield put(getInternsSuccess(result.data.records));
  } catch (err) {
    yield put(getInternsFailed(err));
  }
}
//
function* updateInternStatusSaga(action: ReturnType<typeof updateInternStatus>): any {
  try {
    const { row, status, reason } = action.payload;

    const { data } = yield select((store: RootState) => store.internsReducer.interns);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateInternStatus}${row.id}`, {
      status,
      reason,
    });
    yield put(updateInternStatusSuccess(result.data));
    const updatedInterns = data?.map((intern: { id: number; status: string }) => {
      if (intern.id === row.id) {
        return {
          ...intern,
          status,
        };
      }
      return intern;
    });
    yield put(getInternsSuccess(updatedInterns));
  } catch (err) {
    yield put(updateInternStatusFailed(err));
  }
}
//
function* updateInternSaga(action: ReturnType<typeof updateIntern>): any {
  try {
    const { id, firstName, lastName, personalEmail, phone } = action.payload;

    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    const result = yield call(request.put, endpoints.updateIntern + id, {
      firstName,
      lastName,
      email: personalEmail,
      phone,
    });
    yield put(updateInternSuccess(result.data));
    yield put(getInternDetails(id));
  } catch (err) {
    yield put(updateInternFailed(err));
  }
}

function* getInternDetailsSaga(action: ReturnType<typeof getInternDetails>): any {
  try {
    const internId = action.payload;
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
    const result = yield call(request.get, `${endpoints.getInternsDetails}${internId}`);
    yield put(getInternDetailsSuccess(result.data.user));
  } catch (err) {
    yield put(getInternDetailsFailed(err));
  }
}
function* getInternTransactionSaga(action: ReturnType<typeof getInternTransaction>): any {
  try {
    const internId = action.payload;
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
    const result = yield call(request.get, `${endpoints.getTransaction}${internId}`);
    yield put(getInternTransactionSuccess(result.data));
  } catch (err) {
    yield put(getInternTransactionFailed(err));
  }
}
function* promoteAsEmployeeSaga(action: ReturnType<typeof promoteAsEmployee>): any {
  try {
    const { id, roleId, row } = action.payload;
    const formData = new FormData();
    formData.append('firstName', row.firstName);
    formData.append('lastName', row.lastName);
    formData.append('phone', row.phone);
    formData.append('profileImage', row.profileImage);
    if (row.dob) {
      formData.append('dob', row.dob);
    }
    formData.append('source', row.source);
    formData.append('resume', row.resume);
    formData.append('gender', row.gender);
    formData.append('maritalStatus', row.maritalStatus);
    formData.append('aboutMe', row.aboutMe);
    formData.append('personalEmail', row.personalEmail);
    formData.append('email', row.email);
    formData.append('joiningDate', row.joiningDate);
    formData.append('roleId', roleId);

    if (row.managerId && row.managerId.length > 0) {
      row.managerId.forEach((id: any, index: any) => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        formData.append(`managerId[${index}]`, `${id}`);
      });
    }

    formData.append('designation', row.designation);
    formData.append('department', row.department);
    formData.append('education', JSON.stringify(row.education));
    formData.append('workExperience', JSON.stringify(row.workExperience));

    if (row.bankInformation) {
      formData.append('bankInformation', JSON.stringify(row.bankInformation));
    }
    formData.append('emergencyContact', JSON.stringify(row.emergencyContact));
    formData.append('aadharFront', row.aadharFront);
    formData.append('aadharBack', row.aadharBack);
    formData.append('panFront', row.panFront);
    formData.append('panBack', row.panBack);

    if (row.presentAddress) {
      formData.append('presentAddress', JSON.stringify(row.presentAddress));
    }

    if (row.permanentAddress) {
      formData.append('permanentAddress', JSON.stringify(row.permanentAddress));
    }

    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    const result = yield call(request.put, endpoints.promoteAsEmployee + id, formData);
    yield put(promoteAsEmployeeSuccess(result.data.message));
  } catch (err) {
    yield put(promoteAsEmployeeFailed(err));
  }
}
function* internSagas() {
  yield all([
    takeLatest(
      [getInterns, updateInternSuccess, addEmployeeSuccess, updateEmployeeSuccess],
      getInternSaga
    ),
    takeLatest(updateInternStatus, updateInternStatusSaga),
    takeLatest(getInternDetails, getInternDetailsSaga),
    takeLatest(getInternTransaction, getInternTransactionSaga),
    takeLatest(updateIntern, updateInternSaga),
    takeLatest(promoteAsEmployee, promoteAsEmployeeSaga),
  ]);
}

export { internSagas };
